/* Layout */
import Layout from '@/layout'

/* Router Modules */
const productRouter = {
  path: '/product',
  component: Layout,
  name: 'product',
  redirect: '/product',
  meta: {
    title: '产品上样展示应用'
  },
  children: [
    {
      path: '/product',
      component: () => import('@/views/product/index'),
      name: 'product',
      meta: { title: '产品上样展示应用', affix: true, projectId: 4 }
    },
    {
      path: '/product/detail',
      component: () => import('@/views/product/detail'),
      name: 'productDetail',
      hidden: true,
      meta: { title: '方案详情', affix: true, projectId: 2, guidePath: true, jumpPath: '/product' }
    },
    {
      path: '/product/collect',
      component: () => import('@/views/product/collect'),
      name: 'productCollect',
      hidden: true,
      meta: { title: '需求汇总', affix: true, projectId: 2, guidePath: true, jumpPath: '/product' }
    }
  ]
}

export default productRouter
